import { render, staticRenderFns } from "./SendMessageModal.vue?vue&type=template&id=d6980a06&scoped=true"
import script from "./SendMessageModal.vue?vue&type=script&lang=js"
export * from "./SendMessageModal.vue?vue&type=script&lang=js"
import style0 from "./SendMessageModal.vue?vue&type=style&index=0&id=d6980a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6980a06",
  null
  
)

export default component.exports